import { render } from "./BtnSecondary.vue?vue&type=template&id=07e321ac&scoped=true"
import script from "./BtnSecondary.vue?vue&type=script&lang=js"
export * from "./BtnSecondary.vue?vue&type=script&lang=js"

import "./BtnSecondary.vue?vue&type=style&index=0&id=07e321ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07e321ac"]])

export default __exports__